import Individual from './individual/Advance';
import AdvanceLabel from 'components/organisms/forms/advance/advanceLabelForm';
import CreateAdvance from './create/CreateAdvance';

export default { Individual, AdvanceLabel, CreateAdvance };
